import Vue from 'vue'
import Vuex from 'vuex'
import Http from '@/http/index'
import HttpsEncrypt from "@/http/indexencrypt";
import getCurrentCityName from "@/getCurrentCityName";
import crypto from '@/crypto/crypto'
import axios from "axios";

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        PuserSearch: {
            member_id: localStorage.getItem("userInfoMemberId") ?
                JSON.parse(crypto.get(localStorage.getItem("userInfoMemberId"))).member_id ?
                    JSON.parse(crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : null : null,
            library_id: localStorage.getItem("theme_color") ?
                JSON.parse(crypto.get(localStorage.getItem("theme_color"))).library_id ?
                    JSON.parse(crypto.get(localStorage.getItem("theme_color"))).library_id : 28 : 28,
            content: '',
            terminal_type: 14,//终端类型 1 书籍app 2文库app 3书籍小程序 4书籍墨水屏 5朗读亭 6系统管理端 7自助借还机 8微型图书馆 9书籍查阅机 10电子阅读机 11文库墨水屏 12文库小程序  13阿启泰有声读物小程序 14优质资源 15蒙医药
            type: '',//类型 类型 1书籍 2素材 3文库 4期刊 5视频 6作者 7报刊
            wificode: '',
            devicecode: navigator.userAgent,
            network: '',
            latlon: localStorage.getItem("latlon")?JSON.parse(crypto.get(localStorage.getItem("latlon"))).latlon?JSON.parse(crypto.get(localStorage.getItem("latlon"))).latlon:'':'',
            path: '',
            name: '',
            lang: '',
            ip:'',//网络ip
        },

        uuid: null,//设备唯一码
        network: null,//网络
        latlon: null,//经纬度



        showBgmusic:false,//全局音频播放开关
        audioInfor: '',//听书内容
        operation: 0,//操作音频播放的状态1播放2暂停
        playList:[],//播放列表
        allAudioList:[],//全部歌的列表
        play_audio_id:'',//档期啊播放音频的id
        songSearch:{
            lang: 'mn', //语言 mn zh
            classify_id: 0,//分类id  原创241
            didai_id: 0,//地带分类id
            leixing_id: 0,//歌的分类id
            crowd_id: 0,//人群分类
        },
        page:1,

        PeriodicalClass:[],//杂志、期刊分类
        CulturalClassList: [],//文化分类列表
        ResourceClassList: [],//资源分类列表
        InitialList:[],//首字母
        langNewArr: [],//(语言-智能翻译)

        PeriodicalClassZh:[],//杂志、期刊分类
        CulturalClassListZh: [],//文化分类列表
        ResourceClassListZh: [],//资源分类列表
        InitialListZh:[],//首字母
        langNewArrZh: [],//(语言-智能翻译)
        ztclass:localStorage.getItem('ztclassType')?JSON.parse(localStorage.getItem('ztclassType')):[],//中图分类


        lang:localStorage.getItem('lang'),

    },
    mutations: {
        SET_PuserSearch: (state, [PuserSearch, path, name, type]) => {
            state.PuserSearch.content = PuserSearch
            state.PuserSearch.path = path
            state.PuserSearch.name = name
            state.PuserSearch.type = type
        },


        // 赋值设备唯一码
        SET_CROWDCLASS: (state, uuid) => {
            state.uuid = uuid
        },
        // 赋值网络
        SET_NETWORK: (state, network) => {
            state.network = network
        },
        // 赋值经纬度
        SET_LATLON: (state, latlon) => {
            state.latlon = latlon
        },


        SET_Bgmusic: (state, showBgmusic) => {
            //听书显隐
            state.showBgmusic = showBgmusic
        },
        SET_AudioInfor: (state, audioInfor) => {
            //听书内容
            state.audioInfor = audioInfor
        },
        SET_Operation: (state, operation) => {
            //音频播放状态
            state.operation = operation
        },
        SET_PlayList: (state, playList) => {
            //播放列表
            state.playList = playList
        },
        SET_AllAudioList: (state, allAudioList) => {
            //全部列表
            state.allAudioList = allAudioList
        },
        SET_PlayAudioId: (state, play_audio_id) => {
            //当前播放音频的id
            state.play_audio_id = play_audio_id
        },
        SET_SongSearch: (state, songSearch) => {
            //当前播放音频的id
            state.songSearch = songSearch
        },
        SET_PAGE:(state,page)=>{
            state.page = page
        },
        SET_PeriodicalClass:(state,list)=>{
            state.PeriodicalClass = list
        },
        SET_CulturalClassList:(state,list)=>{
            state.CulturalClassList = list
        },
        SET_ResourceClassList:(state,list)=>{
            state.ResourceClassList = list
        },
        SET_langNewArr:(state,langNewArr)=>{
            state.langNewArr = langNewArr
        },
        SET_InitialList:(state,list)=>{
            state.InitialList = list
        },
        SET_PeriodicalClassZh:(state,list)=>{
            state.PeriodicalClassZh = list
        },
        SET_CulturalClassListZh:(state,list)=>{
            state.CulturalClassListZh = list
        },
        SET_ResourceClassListZh:(state,list)=>{
            state.ResourceClassListZh = list
        },
        SET_langNewArrZh:(state,langNewArr)=>{
            state.langNewArrZh = langNewArr
        },
        SET_InitialListZh:(state,list)=>{
            state.InitialListZh = list
        },
        SET_LANG:(state,lang)=>{
            state.lang = lang
        },
        // 中图分类
        SET_ZTCLASS: (state, ztclass) => {
            state.ztclass = ztclass
        },
    },
    getters: {
        PuserSearch: state => {
            return state.PuserSearch
        },
        uuid: state => state.uuid,
        network: state => state.network,
        latlon: state => state.latlon,

        showBgmusic: state => state.showBgmusic,
        audioInfor: state => state.audioInfor,
        operation: state => state.operation,
        playList: state => state.playList,
        allAudioList: state => state.allAudioList,
        play_audio_id:state => state.play_audio_id,
        songSearch:state => state.songSearch,

        page:state => {
            return state.page
        },
        PeriodicalClass:state => {
            return state.PeriodicalClass
        },
        CulturalClassList:state => {
            return state.CulturalClassList
        },
        ResourceClassList:state => {
            return state.ResourceClassList
        },
        langNewArr:state => state.langNewArr,
        InitialList:state => state.InitialList,

        PeriodicalClassZh:state => {
            return state.PeriodicalClassZh
        },
        CulturalClassListZh:state => {
            return state.CulturalClassListZh
        },
        ResourceClassListZh:state => {
            return state.ResourceClassListZh
        },
        langNewArrZh:state => state.langNewArrZh,
        InitialListZh:state => state.InitialListZh,

        lang: state => state.lang,
        ztclass: state => state.ztclass,

    },
    actions: {
        /*****************************************************************
         *
         * 获取全部音频
         *
         *****************************************************************/
        getAllaodio({commit}, param){
            let query={
                lang:localStorage.getItem("lang"),
                classify_id:param.classify_id?param.classify_id:'',
                didai_id:param.didai_id?param.didai_id:'',
                leixing_id:param.leixing_id?param.leixing_id:'',
                crowd_id:param.crowd_id?param.crowd_id:'',
            }
            HttpsEncrypt.post('api/web/v3/songannex/index', query).then(val => {
                if(val.code==200&&val.data.length){
                    commit('SET_PlayList', val.data)
                }else {
                    commit('SET_PlayList', [])
                }
            }).catch(err => {
                commit('SET_PlayList', [])
            })
        },
        getHedcircle({state}) {
            state.PuserSearch.lang = localStorage.getItem("lang")
            Http.post('api/web/v1/search/searchadd', state.PuserSearch).then(val => {
            }).catch(err => {
            })
        },

        /*****************************************************************
         *
         * 获取设备唯一码
         *
         *****************************************************************/
        getSebeihao({commit}) {
            commit('SET_CROWDCLASS', navigator.userAgent)
        },



        getNetworkType({commit}) {
            if (navigator.onLine) {
                commit('SET_NETWORK', 3)
            } else {
                commit('SET_NETWORK', 1)
            }
        },
        getMap({commit}) {
            getCurrentCityName().then(city=>{

                if(city){
                    var x = city.point.lng - 0.0065, y = city.point.lat - 0.006;
                    let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
                    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
                    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
                    var gcjLon = z * Math.cos(theta);
                    var gcjLat = z * Math.sin(theta);
                    let latlon = gcjLat+','+gcjLon
                    commit('SET_LATLON', latlon)
                    let ln ={
                        latlon:latlon
                    }
                    localStorage.setItem("latlon", crypto.set(JSON.stringify(ln)));
                }



                // let latlon = city?city.point.lat+','+city.point.lng:''
                // commit('SET_LATLON', latlon)
                // let ln ={
                //     latlon:latlon
                // }
                // localStorage.setItem("latlon", JSON.stringify(ln));
            })
        },

        // /************************************************************
        // *
        // * 语言赋值
        // *
        // ************************************************************/
        getLangStore({commit}, lang) {
            commit('SET_LANG', lang)
        },

        /*****************************************************************
         *
         * 记录各个操作
         *
         *****************************************************************/
        saveUserBehavior({getters}, infor) {
            Vue.prototype.$UserBehaviorsort++
            let data = {
                member_id: (localStorage.getItem('userInfoMemberId') ? JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userInfoMemberId'))).member_id : null),// 用户id
                library_id: (localStorage.getItem('theme_color') ? JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('theme_color'))).library_id : (infor.library_id?infor.library_id:null)),// 馆藏id
                book_id: infor.book_id ? infor.book_id : null,// 数据ID（书籍id、期刊id）
                magazine_id: infor.magazine_id ? infor.magazine_id : null,// 杂志id
                type: infor.type ? infor.type : null,// 类型 1书籍 2杂志
                path: infor.path ? infor.path : null,// 路由
                name: infor.mark ? infor.mark : null,//名称
                wificode: getters.wificode,// Wi-Fi码
                devicecode: getters.uuid,//设备码
                network: getters.network,// 网络
                latlon: getters.latlon,// 经纬度
                ip: '',//网络ip
                apptype:'',
                appterminal:'',
                appterminallx:'',
                apiterminal: 'Aqt_20230517ApiWeb',
                terminal: Vue.prototype.$terminal,//终端类型 阿启泰书籍文献APP  产品平板电脑9
                created_at: Vue.prototype.$getNowTime(),//年月日时分秒
                sort: Vue.prototype.$UserBehaviorsort,
                priceclass_id: '',//专题分类id
                menu_id: '',//菜单id

            }
            axios.post('https://culture.aqitai.com/api/web/v1/book/userbehavior', data).then(val => {
            }).catch(err => {
            })

        },

        /************************************************************
         * 获取中图分类号
         ************************************************************/
        getZtclass({commit}) {
            return new Promise((resolve, reject) => {
                HttpsEncrypt.post('api/base/v3/zhongtuclassweb/treeindex', {pid: 0})
                    .then(val => {
                        var arr = []
                        if (val.data.length) {
                            arr = val.data.map((it, ind) => {
                                if (it.child && it.child > 0) {
                                    return {
                                        title: (it.alis ? it.alis : '') + ' ' + (it.titlelang && it.titlelang.zh ? it.titlelang.zh : ''),
                                        expand: false,
                                        loading: false,
                                        value: it.alis ? it.alis : '',
                                        selected: false,
                                        checked: false,
                                        zhongtuclass_id: it.zhongtuclass_id,
                                        pid: it.pid,
                                        childzj: it.child ? it.child : '',
                                        children: []
                                    }
                                } else {
                                    return {
                                        title: (it.alis ? it.alis : '') + ' ' + (it.titlelang && it.titlelang.zh ? it.titlelang.zh : ''),
                                        expand: false,
                                        value: it.alis ? it.alis : '',
                                        selected: false,
                                        checked: false,
                                        zhongtuclass_id: it.zhongtuclass_id,
                                        pid: it.pid,
                                        childzj: it.child ? it.child : '',
                                    }
                                }

                            })
                        }
                        commit('SET_ZTCLASS', arr)
                        localStorage.removeItem("ztclassType");
                        localStorage.setItem("ztclassType", JSON.stringify(arr));
                        resolve()
                    }).catch(err => {
                    reject(err)
                })
            })
        },

    }


})
